import { TEffectVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';

export const EMPTY_EFFECT = 'empty-effect';

export class BasePresetUtil {
    protected presetIcon;
    protected defaultEffectProps;

    public getPresetStyle(effectProps) {
        const iconName = this.getIconName(effectProps);
        const iconSrc = this.presetIcon[iconName];
        return { iconStyle: iconSrc, iconName };
    }

    public getDefaultEffectProps() {
        return this.defaultEffectProps;
    }

    protected getIconName(effectProps: TEffectVal): string {
        return EMPTY_EFFECT;
    }
}
